var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading || !_vm.partnerResource)?_c('fragment',[(_vm.partnerResource)?_c('MobileAppChannel',{attrs:{"channelId":_vm.partnerResource.id}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }